export const formatDate = (date) => {
	const day = String(date.date.getDate()).padStart(2, "0");
	const month = String(date.date.getMonth() + 1).padStart(2, "0");
	const year = date.date.getFullYear();
	const formatedDate = `${day}.${month}.${year}`;

	return {
		content: formatedDate,
		isSelected: date.isSelected,
		title: "Datum",
		icon: date.icon,
	}
}
